/**
 * React Starter Kit (https://www.reactstarterkit.com/)
 *
 * Copyright © 2014-present Kriasoft, LLC. All rights reserved.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.txt file in the root directory of this source tree.
 */

/*eslint-disable no-unused-vars*/
import React from "react";
import withStyles from "isomorphic-style-loader/lib/withStyles";
/*eslint-enable no-unused-vars*/
import ScrollableAnchor, { configureAnchors } from 'react-scrollable-anchor';
import Slider from '../../components/Main/Slider/Home';
import ServicesList from '../../components/Main/Services';
// import SliderMobile from '../../components/Main/Slider/HomeMobile';
import AboutUsList from '../../components/Main/About-us';

import StagesOfWorkList from '../../components/Main/Stages-of-work';
import PortfolioList from '../../components/Main/Portfolio';
import TrustList from '../../components/Main/Trust-us';
// import ContactList from '../../components/Main/Contact';
import s from "../../style/page.css";
import f from '../../style/foundation.min.css';
import jfp from '../../js/vendor/jquery.fullpage.min.css';
import home from "./Home.css";
import {  LgScreen, LgScreenHidden  } from 'react-responsive-redux';



class Home extends React.Component {
    componentWillMount() {
        configureAnchors({scrollDuration: 2000})
    }
    render() {
        return (
            <div className="homePage">
                <ScrollableAnchor id={'mainSliderLink'}>
                    <div id={home.home} className={['section'] + " " + s.section + " " + ['content-wrap']}>
                        <Slider/>
                    </div>
                </ScrollableAnchor>
                <main className={['page-main'] + " " + s['main-anim'] + " " + ['fullpg']} id="mainpage">
                    <ScrollableAnchor id={'serviceLink'} className={['section'] + " " + s.section}>
                        <div id="services" className={['section'] + " " + s.section}>
                            <ServicesList/>
                        </div>
                    </ScrollableAnchor>
                    <div id="stagesOfWork">
                            <StagesOfWorkList/>
                        </div>
                    <ScrollableAnchor id={'projectsLink'}>
                    <div id="projects" className={['section'] + " " + ['fp-auto-height-responsive'] + " " + s.section + " " + ['section-projects'] + " " + jfp['fp-auto-height-responsive'] + " " + ['content-wrap']}>
                            <PortfolioList/>
                        </div>
                    </ScrollableAnchor>
                    <div className={['edgtf-parallax-holder'] + " " + s.marginBlock} data-parallax="{&quot;y&quot;: -100, &quot;smoothness&quot;: 20}">
                            <div className="edgtf-elements-holder   edgtf-one-column  edgtf-responsive-mode-768 ">
                                <div className="edgtf-eh-item" data-item-class="edgtf-eh-custom-8567" data-1024-1280="60px 0 148px 0">
                                    <div className="edgtf-eh-item-inner">
                                        <div className="edgtf-eh-item-content edgtf-eh-custom-8567">
                                            <div id="trust-us" className={['section'] + " " + ['small-bg-color'] + " " + ['fp-auto-height-responsive'] + " " + s.section + " " + s['small-bg-color'] + " " + jfp['fp-auto-height-responsive'] + " " + ['content-wrap'] + " " + f['row'] + " " + s.row}>
                                                <TrustList />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    <ScrollableAnchor id={'aboutUsLink'}>
                        <div className={['edgtf-parallax-holder'] + " " + s.marginBlock} data-parallax="{&quot;y&quot;: -100, &quot;smoothness&quot;: 20}">
                            <div className="edgtf-elements-holder   edgtf-one-column  edgtf-responsive-mode-768 ">
                                <div className="edgtf-eh-item" data-item-class="edgtf-eh-custom-8567" data-1024-1280="60px 0 148px 0">
                                    <div className="edgtf-eh-item-inner">
                                        <div className="edgtf-eh-item-content edgtf-eh-custom-8567">
                                            <div id="about-us" className={['section'] + " " + ['fp-auto-height-responsive'] + " " + s.section + " " + jfp['fp-auto-height-responsive'] + " " + ['content-wrap'] + " " + f['row'] + " " + s.row}>
                                                <AboutUsList/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ScrollableAnchor>
                </main>
            </div>
        );
    }
}

export default withStyles(s, jfp, f, home)(Home);
